import store from '../../store/store';

export function authHeader(roleOverride = null) {
  const state = store.getState();
  const auth = state.auth;

  if (auth && auth.user) {
    const { id, given_name, family_name, role } = auth.user;

    return {
      'X-Proxy-User': JSON.stringify({
        id,
        Name: `${given_name} ${family_name}`,
        Role: roleOverride || role
      })
    };
  }

  return {};
}
